// Country codes loaded from public/flags/countries.json
// Dial codes mapping (ISO 3166-1 alpha-2 to dial code)
const dialCodeMap: Record<string, string> = {
  'US': '+1', 'CA': '+1', 'MX': '+52', 'GB': '+44', 'AU': '+61',
  'DE': '+49', 'FR': '+33', 'ES': '+34', 'IT': '+39', 'BR': '+55',
  'AR': '+54', 'CO': '+57', 'CL': '+56', 'PE': '+51', 'VE': '+58',
  'EC': '+593', 'GT': '+502', 'CU': '+53', 'BO': '+591', 'DO': '+1',
  'HN': '+504', 'PY': '+595', 'SV': '+503', 'NI': '+505', 'CR': '+506',
  'PA': '+507', 'UY': '+598', 'JP': '+81', 'CN': '+86', 'IN': '+91',
  'KR': '+82', 'SG': '+65', 'MY': '+60', 'TH': '+66', 'ID': '+62',
  'PH': '+63', 'VN': '+84', 'AE': '+971', 'SA': '+966', 'ZA': '+27',
  'NG': '+234', 'EG': '+20', 'KE': '+254', 'IL': '+972', 'TR': '+90',
  'RU': '+7', 'NL': '+31', 'BE': '+32', 'CH': '+41', 'AT': '+43',
  'SE': '+46', 'NO': '+47', 'DK': '+45', 'FI': '+358', 'PL': '+48',
  'PT': '+351', 'GR': '+30', 'IE': '+353', 'NZ': '+64', 'AD': '+376',
  'AF': '+93', 'AG': '+1', 'AI': '+1', 'AL': '+355', 'AM': '+374',
  'AO': '+244', 'AQ': '+672', 'AS': '+1', 'AW': '+297', 'AX': '+358',
  'AZ': '+994', 'BA': '+387', 'BB': '+1', 'BD': '+880', 'BF': '+226',
  'BG': '+359', 'BH': '+973', 'BI': '+257', 'BJ': '+229', 'BL': '+590',
  'BM': '+1', 'BN': '+673', 'BQ': '+599', 'BS': '+1', 'BT': '+975',
  'BW': '+267', 'BY': '+375', 'BZ': '+501', 'CC': '+61', 'CD': '+243',
  'CF': '+236', 'CG': '+242', 'CI': '+225', 'CK': '+682', 'CM': '+237',
  'CV': '+238', 'CW': '+599', 'CX': '+61', 'CY': '+357', 'CZ': '+420',
  'DJ': '+253', 'DM': '+1', 'DZ': '+213', 'EE': '+372', 'EH': '+212',
  'ER': '+291', 'ET': '+251', 'FJ': '+679', 'FK': '+500', 'FM': '+691',
  'FO': '+298', 'GA': '+241', 'GD': '+1', 'GE': '+995', 'GF': '+594',
  'GG': '+44', 'GH': '+233', 'GI': '+350', 'GL': '+299', 'GM': '+220',
  'GN': '+224', 'GP': '+590', 'GQ': '+240', 'GS': '+500', 'GU': '+1',
  'GW': '+245', 'GY': '+592', 'HK': '+852', 'HM': '+672', 'HR': '+385',
  'HT': '+509', 'HU': '+36', 'IM': '+44', 'IO': '+246', 'IQ': '+964',
  'IR': '+98', 'IS': '+354', 'JE': '+44', 'JM': '+1', 'JO': '+962',
  'KG': '+996', 'KH': '+855', 'KI': '+686', 'KM': '+269', 'KN': '+1',
  'KP': '+850', 'KW': '+965', 'KY': '+1', 'KZ': '+7', 'LA': '+856',
  'LB': '+961', 'LC': '+1', 'LI': '+423', 'LK': '+94', 'LR': '+231',
  'LS': '+266', 'LT': '+370', 'LU': '+352', 'LV': '+371', 'LY': '+218',
  'MA': '+212', 'MC': '+377', 'MD': '+373', 'ME': '+382', 'MF': '+590',
  'MG': '+261', 'MH': '+692', 'MK': '+389', 'ML': '+223', 'MM': '+95',
  'MN': '+976', 'MO': '+853', 'MP': '+1', 'MQ': '+596', 'MR': '+222',
  'MS': '+1', 'MT': '+356', 'MU': '+230', 'MV': '+960', 'MW': '+265',
  'MZ': '+258', 'NA': '+264', 'NC': '+687', 'NE': '+227', 'NF': '+672',
  'NP': '+977', 'NR': '+674', 'NU': '+683', 'OM': '+968', 'PF': '+689',
  'PG': '+675', 'PK': '+92', 'PM': '+508', 'PN': '+872', 'PR': '+1',
  'PS': '+970', 'PW': '+680', 'QA': '+974', 'RE': '+262', 'RO': '+40',
  'RS': '+381', 'RW': '+250', 'SB': '+677', 'SC': '+248', 'SD': '+249',
  'SH': '+290', 'SI': '+386', 'SJ': '+47', 'SK': '+421', 'SL': '+232',
  'SM': '+378', 'SN': '+221', 'SO': '+252', 'SR': '+597', 'SS': '+211',
  'ST': '+239', 'SX': '+1', 'SY': '+963', 'SZ': '+268', 'TC': '+1',
  'TD': '+235', 'TG': '+228', 'TJ': '+992', 'TK': '+690', 'TL': '+670',
  'TM': '+993', 'TN': '+216', 'TO': '+676', 'TT': '+1', 'TV': '+688',
  'TW': '+886', 'TZ': '+255', 'UA': '+380', 'UG': '+256', 'UM': '+1',
  'UZ': '+998', 'VA': '+39', 'VC': '+1', 'VG': '+1', 'VI': '+1',
  'VU': '+678', 'WF': '+681', 'WS': '+685', 'XK': '+383', 'YE': '+967',
  'YT': '+262', 'ZM': '+260', 'ZW': '+263'
}

export interface CountryCode {
  code: string
  dialCode: string
  name: string
  flagPath: string
}

let countriesCache: CountryCode[] | null = null

// Load countries from JSON file
const loadCountries = async (): Promise<CountryCode[]> => {
  if (countriesCache) {
    return countriesCache
  }

  try {
    const response = await fetch('/flags/countries.json')
    const countriesData: Record<string, string> = await response.json()
    
    countriesCache = Object.entries(countriesData)
      .map(([code, name]) => {
        const dialCode = dialCodeMap[code] || ''
        // Use png100px for smaller file size in dropdowns
        const flagPath = `/flags/png100px/${code.toLowerCase()}.png`
        
        return {
          code,
          dialCode,
          name,
          flagPath
        }
      })
      .filter(country => country.dialCode) // Only include countries with dial codes
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort alphabetically
    
    return countriesCache
  } catch (error) {
    console.error('Error loading countries:', error)
    // Fallback to a small default list if loading fails
    return [
      { code: 'MX', dialCode: '+52', name: 'Mexico', flagPath: '/flags/png100px/mx.png' },
      { code: 'US', dialCode: '+1', name: 'United States', flagPath: '/flags/png100px/us.png' },
      { code: 'CA', dialCode: '+1', name: 'Canada', flagPath: '/flags/png100px/ca.png' },
      { code: 'GB', dialCode: '+44', name: 'United Kingdom', flagPath: '/flags/png100px/gb.png' }
    ]
  }
}

// Export a function to get countries (async)
export const getCountries = async (): Promise<CountryCode[]> => {
  return await loadCountries()
}

// Synchronous version that returns cached data or default
export const countryCodes: CountryCode[] = [
  { code: 'MX', dialCode: '+52', name: 'Mexico', flagPath: '/flags/png100px/mx.png' },
  { code: 'US', dialCode: '+1', name: 'United States', flagPath: '/flags/png100px/us.png' },
  { code: 'CA', dialCode: '+1', name: 'Canada', flagPath: '/flags/png100px/ca.png' }
]

export const getCountryCodeByIso = async (isoCode: string): Promise<CountryCode | undefined> => {
  const countries = await getCountries()
  return countries.find(country => country.code.toLowerCase() === isoCode.toLowerCase())
}

export const getCountryCodeByDialCode = async (dialCode: string): Promise<CountryCode | undefined> => {
  const countries = await getCountries()
  return countries.find(country => country.dialCode === dialCode)
}
